import React from 'react'
import classNames from 'classnames'

import styles from './WGCWXShopCard.scss'

const WGCWXShopHeaderCard = props => (
    <div className={classNames(styles.card, styles.card__large, styles.card__header)}>
        <div className={styles.inner}>
            {props.children}
        </div>
    </div>
)

export default WGCWXShopHeaderCard



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/WGCWXShopHeaderCard.jsx